import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Pinned bottom stack of `<vx-sidebar>` (onboarding card, org switcher, …).
 * Stays visible while the middle region scrolls.
 */
@Component({
  selector: 'vx-sidebar-footer',
  templateUrl: './sidebar-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex shrink-0 flex-col gap-2 px-3 pt-3' },
})
export class VxSidebarFooterComponent {}
